<template>
  <CCharts class="w-data-chart" v-bind="chartAttrs"></CCharts>
</template>

<script setup lang="ts">
import { _, computed, useCurrentAppInstance } from '@zto/zpage'

import type { PageSchema } from '@zto/zpage'

// 属性
const props = defineProps<{
  schema: PageSchema
}>()

const app = useCurrentAppInstance()

const wSchema = app.useComputedWidgetSchema(props.schema || {})

const chartAttrs = computed(() => {
  return _.omit(wSchema.value, ['type', 'body'])
})
</script>

<style lang="scss" scoped></style>
